module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_22_B.334878eb.mp3";